import React from "react";
import styles from "@/src/styles/spinner.module.css";

const Spinner = () => (
  <div className={styles.spinnerOverlay}>
    <div className={styles.spinnerContainer} />
  </div>
);

export default Spinner;
